export default __webpack_public_path__ + "img/default-a842ccdc.png";